














import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import userStore from "@/store/userStore";

@Component
export default class ExpandableImage extends Vue {
  @Prop(String) readonly src: string | undefined;
  expanded = false;
  closeButtonRef: Element | null = null;
  cloned: Node | null = null;
  userStore = userStore;

  closeImage(event: Event) {
    this.expanded = false;
    event.stopPropagation();
  }

  freezeVp(e: Event) {
    e.preventDefault();
  }

  handleEscapePress(event: KeyboardEvent) {
    if (event.key === "Escape") {
      event.stopPropagation();
      this.closeImage(event);
    }
  }

  @Watch("userStore.isImageMaximized")
  onIsImageMaximizedChanged(status: boolean) {
    this.$nextTick(() => {
      if (status === false && this.expanded === true) {
        this.expanded = false;
      }
    });
  }

  @Watch("expanded")
  onExpandedChanged(status: boolean) {
    this.$nextTick(() => {
      if (status) {
        this.cloned = this.$el.cloneNode(true);
        if (!this.cloned) return;
        this.closeButtonRef = (this.cloned as Element).querySelector(".close-button");
        if (!this.closeButtonRef) return;
        this.closeButtonRef.addEventListener("click", this.closeImage);
        window.addEventListener("keydown", this.handleEscapePress, true);
        userStore.isImageMaximized = true;
        document.body.appendChild(this.cloned);
        document.body.style.overflow = "hidden";
        setTimeout(() => {
          if (!this.cloned) return;
          (this.cloned as HTMLElement).style.opacity = "1";
        }, 0);
      } else {
        if (!this.cloned) return;
        (this.cloned as HTMLElement).style.opacity = "0";
        setTimeout(() => {
          if (!this.closeButtonRef) return;
          if (!this.cloned) return;
          this.closeButtonRef.removeEventListener("click", this.closeImage);
          window.removeEventListener("keydown", this.handleEscapePress);
          userStore.isImageMaximized = false;
          (this.cloned as HTMLElement).remove();
          this.cloned = null;
          this.closeButtonRef = null;
          document.body.style.overflow = "auto";
        }, 250);
      }
    });
  }
}
